import { formatAboPV } from "../../../../components/Lit/acc-mixins/l10n.js";
import { storedLocale, marketCode } from "../../../../components/Authentication/util";

type Props = {
  pv: number;
};

export const LeafPV = (props: Props) => {
  const { pv } = props;
  const locale = storedLocale();
  const market = marketCode();

  return <>{formatAboPV(pv, locale, market)}</>;
};
